import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-5dc9c92a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Skip ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "caret right" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "element-img-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex-start star-text-box" }
const _hoisted_13 = { class: "stars name-left-align" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-padding" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Extra", -1))
const _hoisted_16 = {
  key: 0,
  class: "extra-text flex-start"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Masterless Stardust", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "x15", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "extra-text flex-start starglitter"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Masterless Starglitter", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_explosion_overlay = _resolveComponent("explosion-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    false
      ? (_openBlock(), _createBlock(_component_explosion_overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([3, 4, 5], (i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (_ctx.currentIndex === 0 && _ctx.currentItem.rarity === i)
          ? (_openBlock(), _createElementBlock("audio", {
              key: 0,
              ref_for: true,
              ref: "audioItemReveal",
              preload: "auto",
              onCanplaythrough: _cache[0] || (_cache[0] = ($event: any) => {if (_ctx.animationIndex < 0) _ctx.nextAnimation();})
            }, [
              _createElementVNode("source", {
                src: require(`@/assets/audio/${i}-star-wish-reveal-first.ogg`),
                type: "audio/ogg"
              }, null, 8, _hoisted_1),
              _createElementVNode("source", {
                src: require(`@/assets/audio/${i}-star-wish-reveal-first.mp3`),
                type: "audio/mpeg"
              }, null, 8, _hoisted_2)
            ], 544))
          : (_ctx.currentItem.rarity === i)
            ? (_openBlock(), _createElementBlock("audio", {
                key: 1,
                ref_for: true,
                ref: "audioItemReveal",
                preload: "auto",
                onCanplaythrough: _cache[1] || (_cache[1] = ($event: any) => {if (_ctx.animationIndex < 0) _ctx.nextAnimation();})
              }, [
                _createElementVNode("source", {
                  src: require(`@/assets/audio/${i}-star-wish-reveal.ogg`),
                  type: "audio/ogg"
                }, null, 8, _hoisted_3),
                _createElementVNode("source", {
                  src: require(`@/assets/audio/${i}-star-wish-reveal.mp3`),
                  type: "audio/mpeg"
                }, null, 8, _hoisted_4)
              ], 544))
            : _createCommentVNode("", true)
      ], 64))
    }), 64)),
    _createElementVNode("button", {
      class: "skip-button",
      type: "button",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.skip && _ctx.skip(...args)))
    }, _hoisted_7),
    _createElementVNode("div", {
      class: "item-picture",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextItem && _ctx.nextItem(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({
        transparent: _ctx.animationIndex < 0,
        'glow-box': true,
        'glow-animated': _ctx.animationIndex >= 0,
        blue: _ctx.currentItem.rarity === 3,
        purple: _ctx.currentItem.rarity === 4,
        gold: _ctx.currentItem.rarity === 5,
      })
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass({
        transparent: _ctx.animationIndex < 0,
        'glow-box': true,
        'glow-box-big': true,
        'glow-animated': _ctx.animationIndex >= 0,
        blue: _ctx.currentItem.rarity === 3,
        purple: _ctx.currentItem.rarity === 4,
        gold: _ctx.currentItem.rarity === 5,
      })
      }, null, 2),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Bow', 'Catalyst', 'Claymore', 'Polearm', 'Sword'], (weapon) => {
        return _createElementVNode("img", {
          key: weapon,
          src: _ctx.getWeaponBgImage(weapon),
          class: _normalizeClass([
        {
          'active-bg-img': true,
          nofilter: true,
          'display-none': _ctx.currentItem.element !== weapon || _ctx.animationIndex < 0,
          transparent: _ctx.animationIndex <= 0,
          'animate-weapon-bg': _ctx.animationIndex === 1,
        },
      ])
        }, null, 10, _hoisted_8)
      }), 64)),
      _createElementVNode("img", {
        src: _ctx.currentItemImage,
        class: _normalizeClass({
        'animate-image': _ctx.animationIndex === 1,
        'zoom-image': _ctx.animationIndex === 0,
        'active-img': true,
        'active-img-weapon': _ctx.currentItem.type === 'Weapon',
        transparent: _ctx.animationIndex < 0,
      }),
        alt: _ctx.currentItemImage,
        onAnimationstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.playSfx && _ctx.playSfx(...args))),
        onAnimationend: _cache[4] || (_cache[4] = ($event: any) => {if (_ctx.animationIndex < 2) _ctx.nextAnimation();}),
        onLoad: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextAnimation && _ctx.nextAnimation(...args)))
      }, null, 42, _hoisted_9)
    ]),
    _createElementVNode("div", {
      class: "item",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextItem && _ctx.nextItem(...args)))
    }, [
      _createElementVNode("div", {
        id: "item-reveal-description-box",
        class: _normalizeClass({
        'name-rarity': true,
        'name-rarity-left-push': _ctx.currentItem.type === 'Character',
      })
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass({ transparent: _ctx.animationIndex < 0, 'element-glow-box': true })
          }, null, 2),
          _createElementVNode("img", {
            src: 
            require(`@/assets/images/icons/icon-element-${_ctx.currentItem.element}.webp`)
          ,
            class: _normalizeClass({
            'element-img': true,
            'element-img-weapon': _ctx.currentItem.type === 'Weapon',
            transparent: _ctx.animationIndex <= 0,
            'appear-slide-left-element': _ctx.animationIndex >= 1,
          })
          }, null, 10, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", {
            class: _normalizeClass({
            'name-text': true,
            'name-left-align': true,
            transparent: _ctx.animationIndex <= 0,
            'appear-slide-left': _ctx.animationIndex === 1,
          })
          }, _toDisplayString(_ctx.currentItem.name), 3),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentItem.rarity, (n) => {
              return (_openBlock(), _createElementBlock("span", { key: n }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: _normalizeClass({
                transparent: _ctx.animationIndex < n + 1,
                delayed: n === 1 && _ctx.animationIndex === n + 1,
                'star-pop-in': _ctx.animationIndex === n + 1,
              }),
                  alt: "star",
                  onAnimationend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextAnimation && _ctx.nextAnimation(...args)))
                }, null, 34)
              ]))
            }), 128))
          ])
        ])
      ], 2),
      _hoisted_14,
      _createElementVNode("div", {
        class: _normalizeClass([
        'extra-dust-glitter',
        'flex-start',
        {
          'starglitter-slide-in': _ctx.animationIndex >= 2,
          transparent: _ctx.animationIndex < 2 || _ctx.currentItem.type === 'Character',
        },
      ])
      }, [
        _hoisted_15,
        (_ctx.currentItem.rarity === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("p", null, "x" + _toDisplayString(_ctx.currentItem.rarity === 4 ? 2 : 10), 1)
            ]))
      ], 2)
    ])
  ], 64))
}